import React, { useState, useEffect, useRef } from "react";
import { Button, Container } from "react-bootstrap";
import "../assets/styles/Hero.css";

const words = ["Web Apps", "System Integrations", "AI Systems", "Automations", "Mobile Apps"];

const Hero = () => {
  const [currentWord, setCurrentWord] = useState(words[0]);
  const [fade, setFade] = useState(true);
  const indexRef = useRef(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        indexRef.current = (indexRef.current + 1) % words.length;
        setCurrentWord(words[indexRef.current]);
        setFade(true);
      }, 500);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-section reduced-gap">
      <Container className="hero-content">
        {/* Heading */}
        <h1 className="hero-title">
          <span className="animated-word-wrapper">
            <span className={`highlight-hero ${fade ? "fade-in" : "fade-out"}`}>
              {currentWord}
            </span>
          </span>
        </h1>

        <h1 className="hero-subtitle">On-Time. On-Budget.</h1>

        {/* Description */}
        <p className="hero-description">
          Navigating the digital landscape with custom software<br /> and virtual team solutions, enabling businesses to excel.
        </p>

        {/* Search Bar */}
        <Button
          style={{
            backgroundColor: 'white',
            color: 'black',
            border: 'none',
            margin: '50px 0 50px 0', // mt-4 mb-5 equivalent
            padding: '0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '28%',
            borderRadius: '10px',
          }}
        >
          <p style={{
            color: 'black',
            fontWeight: 'bold',
            fontSize: '17px',
            margin: '0',
            padding: '12px 16px',
          }}>
            Let's Build Together
          </p>
        </Button>
      </Container>
    </section>
  );
};

export default Hero;